/* unplugin-vue-components disabled */import { render } from "./tracker-topics.vue?vue&type=template&id=4e540b00&scoped=true"
import script from "./tracker-topics.vue?vue&type=script&lang=js"
export * from "./tracker-topics.vue?vue&type=script&lang=js"

import "./tracker-topics.vue?vue&type=style&index=0&id=4e540b00&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e540b00"],['__file',"src/components/widgets/tracker/tracker-topics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e540b00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e540b00', __exports__)) {
    api.reload('4e540b00', __exports__)
  }
  
  module.hot.accept("./tracker-topics.vue?vue&type=template&id=4e540b00&scoped=true", () => {
    api.rerender('4e540b00', render)
  })

}


export default __exports__